import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFacebookPostsApi, receiveFacebookWebhookApi, sendFacebookMessageApi, verifyFacebookWebhookApi } from "../../api/ecommerce/FacebookApi";

const initialState = {
  posts: null,
  listing: false,
  verification: null,
  verifying: false,
  webhookResponse: null,
  receiving: false,
  sentMessage: null,
  sending: false,
  error: null,
};
const errorPayload = (err) => ({
  errorMessage: err?.response?.data?.message || err?.response?.data?.error || err?.message || "Something went wrong",
});

export const getFacebookPosts = createAsyncThunk(
  "facebook/getFacebookPosts",
  async (payload, { rejectWithValue }) => {
    try { return (await getFacebookPostsApi(payload))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

// Dispatch with { tenant, mode, verifyToken, challenge }.
export const verifyFacebookWebhook = createAsyncThunk(
  "facebook/verifyFacebookWebhook",
  async ({ tenant, ...params }, { rejectWithValue }) => {
    try { return (await verifyFacebookWebhookApi(tenant, params))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

// Dispatch with { tenant, body: originalSerializedJson, signature? }.
export const receiveFacebookWebhook = createAsyncThunk(
  "facebook/receiveFacebookWebhook",
  async ({ tenant, body, signature }, { rejectWithValue }) => {
    try { return (await receiveFacebookWebhookApi(tenant, body, signature))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

export const sendFacebookMessage = createAsyncThunk(
  "facebook/sendFacebookMessage",
  async (body, { rejectWithValue }) => {
    try { return (await sendFacebookMessageApi(body))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

const facebookSlice = createSlice({
  name: "facebook",
  initialState,
  reducers: {
    clearFacebookError: (state) => { state.error = null; },
    clearFacebookState: () => initialState,
  },
  extraReducers: (builder) => {
    [
      [getFacebookPosts, "posts", "listing"],
      [verifyFacebookWebhook, "verification", "verifying"],
      [receiveFacebookWebhook, "webhookResponse", "receiving"],
      [sendFacebookMessage, "sentMessage", "sending"],
    ].forEach(([thunk, key, flag]) => {
      builder
        .addCase(thunk.pending, (state) => { state[flag] = true; state.error = null; })
        .addCase(thunk.fulfilled, (state, action) => { state[flag] = false; state[key] = action.payload?.response ?? action.payload; })
        .addCase(thunk.rejected, (state, action) => { state[flag] = false; state.error = action.payload?.errorMessage || action.error?.message || "Something went wrong"; });
    });
  },
});

export const { clearFacebookError, clearFacebookState } = facebookSlice.actions;
export default facebookSlice.reducer;
